export function setUIVersion(version) {
  // 仅允许特定的 UI 版本
  let ui;
  switch (version) {
    case "8.2":
      ui = "v8-2";
      break;
    default:
      ui = "v8";
  }
  document.documentElement.dataset.ui = ui;
}
//# sourceMappingURL=setUIVersion.js.map